import { render, staticRenderFns } from "./GlobalAudioPlayer.vue?vue&type=template&id=408c9640&scoped=true&"
import script from "./GlobalAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./GlobalAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAudioPlayer.vue?vue&type=style&index=0&id=408c9640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c9640",
  null
  
)

export default component.exports